module.exports = __webpack_public_path__ + "static/vf_wpants2_core.6f33f1c5.svg";